import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Website from './Website';


ReactDOM.render(
  <React.StrictMode>
    <Website />
  </React.StrictMode>,
  document.getElementById('root')
);
